import { HttpResponseBase } from "@angular/common/http";
import { ClassProvider, ErrorHandler, inject, Injectable, Injector, NgZone } from "@angular/core";
import { ToastService } from "@siemens/ix-angular";

export const provideAppErrorHandler = (): ClassProvider => ({ provide: ErrorHandler, useClass: AppErrorHandler });

@Injectable()
export class AppErrorHandler extends ErrorHandler {
  protected readonly injector = inject(Injector);
  protected readonly ngZone = inject(NgZone);

  public override handleError(err: unknown): void {
    try {
      if (err && !(err instanceof HttpResponseBase)) {
        this.ngZone.run(() => {
          // Unfortunately not all error objects are instances of Error (ie. GeolocationPositionError)
          const message =
            typeof err === "object" && "message" in err && typeof err.message === "string" ? err.message : typeof err === "string" ? err : undefined;
          if (message) {
            this.injector.get(ToastService, null, { optional: true })?.show({
              message,
              type: "error",
            });
          }
        });
      }
    } catch (innerError: unknown) {
      super.handleError(innerError);
    }
    super.handleError(err);
  }
}
